<template>
  <div class="home">
    <div class="container is-fluid">
      <page-header :entity="$entitiesName.PaymentType">
        <h1 class="title">{{ $t("entities.paymentTypes") }}</h1>
      </page-header>

      <datatable
        ref="paymentTypes"
        :fetch="$api.fetchPaymentTypes"
        :enableDownload="false"
        objectName="payment_type"
        identifier="name"
      >
        <div
          slot="name"
          slot-scope="{ item }"
          :title="$t('common.name')"
          :sortable="true"
        >
          {{ item.name }}
        </div>
        <div
          slot="oracleCode"
          slot-scope="{ item }"
          :title="$t('common.oracleCode')"
          :sortable="true"
        >
          {{ item.oracleCode }}
        </div>
        <div slot="actions" slot-scope="{ item }">
          <router-link
            :to="'/paymenttype/' + item.id"
            class="button is-primary"
          >
            <i class="fa fa-search"></i>
          </router-link>
        </div>
      </datatable>
    </div>
  </div>
</template>

<script>
export default {
  name: "PaymentTypeList",
};
</script>
